import { Controller } from "stimulus"

// Copy button for server-rendered pages (the cron example pages). Copies the
// button's data-clipboard-text and adds a `copied` class for two seconds,
// which the page's CSS uses to swap the label:
//
//   <button data-controller="clipboard" data-action="clipboard#copy"
//     data-clipboard-text="*/5 * * * *">...</button>
export default class ClipboardController extends Controller {

  connect() {
    // A Turbo snapshot can hold the button mid-confirmation.
    this.element.classList.remove('copied')
  }

  copy() {
    navigator.clipboard.writeText(this.data.get('text')).then(() => {
      this.element.classList.add('copied')
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => this.element.classList.remove('copied'), 2000)
    })
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
